import { render, staticRenderFns } from "./SolarNova2.vue?vue&type=template&id=339d48aa"
import script from "./SolarNova2.vue?vue&type=script&lang=js"
export * from "./SolarNova2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports